export default __webpack_public_path__ + "static/media/hht2_ani_15.d3a2e2cd.png";